<script setup lang="ts">
  import { computed, ref } from 'vue'
  import FlowCardQC from '@/shared/components/FlowCardQC/FlowCardQC.vue'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import { useI18n } from 'vue-i18n'
  import { useTimeoutFn } from '@vueuse/core'

  const { t } = useI18n()

  const phase = ref(0)

  useTimeoutFn(() => (phase.value = 1), 5000)
  useTimeoutFn(() => (phase.value = 2), 10000)

  const KEYS = [
    t('travel.common.quote_loader.text_1'),
    t('travel.common.quote_loader.text_2'),
    t('travel.common.quote_loader.text_3'),
  ]

  const description = computed(() => KEYS[phase.value])
</script>

<template>
  <FlowCardQC :with-button="false" class="flow-quote-loader">
    <WrapperQC direction="column" gap="var(--spacing-8)">
      <div class="quote-animation">
        <div class="quote-animation__inner">
          <img src="./assets/images/clouds.svg" alt="clouds" class="quote-animation__clouds" />
          <img src="./assets/images/earth.svg" alt="earth" class="quote-animation__earth" />
        </div>
        <img src="./assets/images/plane.png" alt="plane" class="quote-animation__plane" />
      </div>

      <p class="paragraph-default text-center">
        {{ description }}
      </p>
    </WrapperQC>

  </FlowCardQC>
</template>

<style lang="scss" scoped>
  .flow-quote-loader {
    padding: var(--spacing-9);
  }

  .quote-animation {
    position: relative;
    margin: 0 auto;
    background-color: var(--colorArabianBlue50);
    border-radius: var(--radius-8);
  }
  
  .quote-animation__inner {
    position: relative;
    width: 180px;
    height: 220px;
    overflow: hidden;
    border-radius: inherit;
  }

  .quote-animation__clouds,
  .quote-animation__earth,
  .quote-animation__plane {
    position: absolute;
  }

  .quote-animation__clouds {
    left: 0;
    top: 0;
    animation: clouds-animation 4s linear infinite;
  }

  .quote-animation__earth {
    bottom: 0;
    left: 0;
    animation: earth-animation 1.5s linear infinite;
  }

  .quote-animation__plane {
    width: 263px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: plane-float 5s linear infinite;
  }

  .rtl,
  [dir='rtl'] {
    .quote-animation {
      transform: scaleX(-1);
    }
  }

  @keyframes earth-animation {
    to {
      transform: translateX(-500px);
    }
  }

  @keyframes clouds-animation {
    to {
      transform: translateX(-803px);
    }
  }

  @keyframes plane-float {
    0%,
    100% {
      transform: translate(-50%, -50%);
    }
    25% {
      transform: translate(-48%, -55%);
    }
    50% {
      transform: translate(-52%, -48%);
    }
    75% {
      transform: translate(-50%, -53%);
    }
  }
</style>
